import { Loader } from 'google-maps';
import { DEFAULTS } from '../../../config';
import { reportError } from '../../../lib/reportError';

export const loadGoogleMapsPlaces = (onLoad?: () => void) => {
  if (!window.google?.maps.places) {
    try {
      const loader = new Loader(DEFAULTS.GOOGLE_KEY, {
        libraries: ['places']
      });
      loader.load().then(onLoad);
    } catch (error) {
      reportError('LOAD_GOOGLE_MAPS_PLACES', error);
    }
  } else {
    onLoad && onLoad();
  }
};
